import colors from "../base/colors";
import boxShadows from "../base/boxShadows";

import rgba from "../functions/rgba";

const { transparent, grey, background, text } = colors;

const appBar = {
  defaultProps: {
    elevation: 0,
  },

  styleOverrides: {
    root: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      backdropFilter: "blur(10px)",
      borderBottom: `1px solid ${rgba(grey[200], 0.8)}`,
      boxShadow: boxShadows.sm,
      color: text.main,
      padding: "0.25rem 0.5rem",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "& .MuiToolbar-root": {
        minHeight: "auto",
        padding: 0,
      },

      "&.MuiAppBar-colorPrimary": {
        backgroundColor: background.paper,
        backgroundImage: "none",
        color: text.main,
      },
    },

    colorPrimary: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorSecondary: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorInherit: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      color: text.main,
    },

    colorTransparent: {
      backgroundColor: transparent.main,
      color: grey[700],
      boxShadow: "none",
      borderBottom: "none",
    },
  },
};

export default appBar;
